module.exports = __webpack_public_path__ + "img/08.53aa2009.png";